import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";

@Entity('line_items')
export class LineItemsEntity {

    @PrimaryGeneratedColumn("increment", {
        name: "id",
    })
    id: number;

    @Column('varchar', {
        nullable: true,
        name: "headers_id",
    })
    headerId: number;

    @Column('varchar', {
        nullable: true,
        name: "SNo",
    })
    SNo: string;

    @Column('varchar', {
        nullable: true,
        name: "item_description",
    })
    itemDescription: string;

    @Column('varchar', {
        nullable: true,
        name: "description1",
    })
    description1: string;

    @Column('varchar', {
        nullable: true,
        name: "description2",
    })
    description2: string;

    @Column('varchar', {
        nullable: true,
        name: "quantity",
    })
    quantity: string;

    @Column('varchar', {
        nullable: true,
        name: "unit_measurement",
    })
    unitMeasurement: string;

    @Column('varchar', {
        nullable: true,
        name: "price",
    })
    price: string;

    @Column('varchar', {
        nullable: true,
        name: "price_unit",
    })
    priceUnit: string;

    @Column('varchar', {
        nullable: true,
        name: "line_amount",
    })
    lineAmount: string;

    @Column('varchar', {
        nullable: true,
        name: "item_number",
    })
    itemNumber: string;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: string;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: string;

    @Column('int', {
        nullable: true,
        name: 'version',
    })
    version: number;

    @Column({
        nullable: false,
        name: "is_active",
        default: 1
    })
    isActive: boolean;
}